module.exports = __webpack_public_path__ + "img/62_5.f0879ccf.png";